<template>
	<div class="all-son">
		<div class="header-contain">
			<el-row>
				<el-col :span="20">
					<el-form :inline="true" :model="requestData" class="demo-form-inline">
						<el-form-item label="投保情况">
							<el-select v-model="requestData.SituationOfInsurance" placeholder="请选择" style="width:100px">
								
								<el-option v-for="item in SituationOfInsuranceList" :key="item.value" :label="item.name"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="企业名称">
							<el-input v-model="requestData.Name"></el-input>
						</el-form-item>
						<el-form-item label="申请编号">
							<el-input v-model="requestData.serialNo"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button size="small" type="primary" @click="search">查询</el-button>
							<el-button size="small" @click="reset">重置</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="4">
					<div class="text-right">
						<span class="color-blue pointer" @click="DescDocVisibel = true">
							<i class="el-icon-paperclip"></i>安全生产责任险说明</span>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="table-all">
			<div class="table-top">
				<span class="table-but1" @click="applyHandler(null, 'add')" v-if="isBtn">投保</span>
				<span class="table-but2" @click="reset">刷新</span>
			</div>
			<el-table v-loading="loading" :data="tableData" :height="$store.state.tab.tableHeight">
				<el-table-column prop="serialNo" label="申请编号" align="left" width="140"> </el-table-column>
				<el-table-column prop="name" label="企业名称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="isIdentical" label="是否被保险人" align="center" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.isIdentical">是</span>
						<span v-else>否</span>
					</template>
				</el-table-column>
				<el-table-column prop="insuranceSituationText" label="投保情况" align="center"
					:show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="status" label="投保状态" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-tooltip effect="dark" placement="top">
						
						<div slot="content" v-if="scope.row.status==0">
							等待保险机构确认
						</div>
						<div slot="content" v-if="scope.row.status==1">
							审核不通过
						</div>
						<div slot="content" v-if="scope.row.status==2">
							审核通过，正在投保
						</div>
						<div slot="content" v-if="scope.row.status==3">
							保险已出单，可下载保单
						</div>
						
						<span class="badge el-button--primary is-plain" v-if="scope.row.status==0">待审核</span>
						<span class="badge el-button--danger is-plain" v-else-if="scope.row.status==1">未通过</span>

						<span class="badge badge-bg-green" v-else-if="scope.row.status==2">审核通过</span>
						<span class="badge el-button--success is-plain" v-else-if="scope.row.status==3">已出单</span>

					</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="socialCreditCode" label="统一社会信用代码" width="180" align="center"
					:show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="contacts" label="联系人" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="contactPhone" label="联系电话" width="120" align="center"
					:show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="email" label="邮箱" align="center" width="120" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="natureOfBusinessText" label="经营范围" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="personNum" label="投保人数" align="center" :show-overflow-tooltip="true">
				</el-table-column>


				<el-table-column fixed="right" label="操作" :width="isBtn ? 200 : 100">
					<template slot-scope="scope">

						<el-button type="text" size="small"
							v-if="(scope.row.status == 0 || scope.row.status == 1) && scope.row.tenantId == tenantId"
							@click="applyHandler(scope.row, 'edit')">编辑
						</el-button>
						<el-button type="text" size="small" @click="applyHandler(scope.row, 'see')">详情
						</el-button>
						<el-button type="text" size="small" v-if="scope.row.tenantId == tenantId"
							@click="uploadPerson(scope.row)">修改人员信息
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination background :current-page="currentPage" layout="total, sizes, prev, pager, next, jumper"
				:total="total" class="text-right" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="applyDialogTitle" :visible.sync="applyDialogVisible" :close-on-click-modal="false"
			width="75%" @close="caclelisblity">
			<div class="is-pad-10-20 border-5 width-100d badge-bg-blue " v-if="applyData.status==0">待审核</div>
			<div class="is-pad-10-20 border-5 width-100d badge-bg-red" v-else-if="applyData.status==1">审核未通过
			<span class="is-pad-0-20 ">{{applyData.auditRemark}}</span>
			</div>
			<div class="is-pad-10-20 border-5 width-100d badge-bg-green" v-else-if="applyData.status==2">审核通过，正在投保
			</div>
			<div class="is-pad-10-20 border-5 width-100d el-button--success" v-else-if="applyData.status==3">
				已出单</div>
			
			<div class="cre-all">
				<el-form :model="applyData" :rules="applyData_rules" ref="ruleForm" label-width="120px"
					class="demo-ruleForm " :class="applyDialogDisabled ? ' form-disable-none ' : ''"
					:disabled="applyDialogDisabled">
					<el-divider content-position="center">投保信息</el-divider>
					<el-row class="el-row-flex">
						<el-col :span="12">

							<el-form-item label="是否同被保险人" prop="isIdentical">
								<el-radio-group v-model="applyData.isIdentical">
									<el-radio :label="true">是</el-radio>
									<el-radio :label="false">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="投保情况:" prop="situationOfInsurance">
								<el-radio-group v-model="applyData.situationOfInsurance">
									<el-radio v-for="item in SituationOfInsuranceList" :label="item.value"
										:key="item.value" v-if="item.value>0">{{ item.name }}</el-radio>
								</el-radio-group>
							</el-form-item>

						</el-col>
						<el-col :span="12">
							<el-form-item label="企业名称:" prop="name">
								<el-input class="cre-all-inp" v-model="applyData.name" placeholder="请输入企业名称"></el-input>
							</el-form-item>

						</el-col>
						<el-col :span="12">
							<el-form-item label="社会信用代码:" prop="socialCreditCode">
								<el-input class="cre-all-inp" v-model="applyData.socialCreditCode"
									placeholder="请输入社会信用代码"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系人:" prop="contacts">
								<el-input class="cre-all-inp" v-model="applyData.contacts" placeholder="请输入联系人">
								</el-input>
							</el-form-item>

						</el-col>
						<el-col :span="12">
							<el-form-item label="联系电话:" prop="contactPhone">
								<el-input class="cre-all-inp" v-model="applyData.contactPhone" placeholder="请输入联系电话">
								</el-input>
							</el-form-item>

						</el-col>
						<el-col :span="12">
							<el-form-item label="Email:" prop="email">
								<el-input class="cre-all-inp" v-model="applyData.email" placeholder="请输入邮箱"></el-input>
							</el-form-item>

						</el-col>
						<el-col :span="24">
							<el-form-item label="通信地址:" prop="adress">
								<el-input class="cre-all-inp" v-model="applyData.adress" placeholder="请输入通信地址">
								</el-input>
							</el-form-item>

						</el-col>
<!-- 						
						<el-col :span="24" v-if="applyData.status == 1">

							<div class="red-tip">审核未通过</div>
							<el-form-item label="审核意见:">
								{{ applyData.auditRemark }}
							</el-form-item>
						</el-col> -->
						


					</el-row>
					<div v-if="applyData.isIdentical == false">
						<el-divider content-position="center">被保险人信息</el-divider>
						<el-row class="el-row-flex">
							<el-col :span="12">
								<el-form-item label="企业名称:" prop="name_Insured">
									<el-input class="cre-all-inp" v-model="applyData.name_Insured"
										placeholder="请输入企业名称"></el-input>
								</el-form-item>

							</el-col>
							<el-col :span="12">
								<el-form-item label="社会信用代码:" prop="socialCreditCode_Insured">
									<el-input class="cre-all-inp" v-model="applyData.socialCreditCode_Insured"
										placeholder="请输入社会信用代码"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="联系人:" prop="contacts_Insured">
									<el-input class="cre-all-inp" v-model="applyData.contacts_Insured"
										placeholder="请输入联系人"></el-input>
								</el-form-item>

							</el-col>
							<el-col :span="12">
								<el-form-item label="联系电话:" prop="contactPhone_Insured">
									<el-input class="cre-all-inp" v-model="applyData.contactPhone_Insured"
										placeholder="请输入联系电话"></el-input>
								</el-form-item>

							</el-col>
							<el-col :span="12">
								<el-form-item label="Email:" prop="email_Insured">
									<el-input class="cre-all-inp" v-model="applyData.email_Insured" placeholder="请输入邮箱">
									</el-input>
								</el-form-item>

							</el-col>
							<el-col :span="24">
								<el-form-item label="通信地址:" prop="adress_Insured">
									<el-input class="cre-all-inp" v-model="applyData.adress_Insured"
										placeholder="请输入通信地址"></el-input>
								</el-form-item>

							</el-col>
							
						</el-row>

					</div>
					<el-divider content-position="center">投保标的信息</el-divider>
					<el-row class="el-row-flex">
						<el-col :span="12">
							<el-form-item label="经营范围:" prop="natureOfBusiness">
								<el-radio-group v-model="applyData.natureOfBusiness">
									<el-radio v-for="item in NatureOfBusinessList" :label="item.value"
										:key="item.value">{{ item.name }}</el-radio>
								</el-radio-group>
							</el-form-item>

						</el-col>
						<el-col :span="12">
							<el-form-item label="投保人数:" prop="personNum">
								<el-input class="cre-all-inp" v-model.number="applyData.personNum"
									placeholder="请输入投保人数"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="保险公司:" prop="insuranceCompnayId">

								<el-select v-model="applyData.insuranceCompnayId" placeholder="请选择" disabled
									@change="changeCompnay" style="width: 340px;">
									<el-option v-for="item in InsuranceCompnayList" :key="item.value" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
								<div style="display: inline-block;" class="color-blue pointer"
									@click="CompnayDescVisibel = true;"><i class="el-icon-paperclip">企业简介</i></div>
								<div style="margin-left: 1rem;    display: inline-block;">
									联系方式：电话 {{ insuranceCompnayInfo.tenantPhone }}
									<span style="padding-left: 1rem;">邮箱 {{ insuranceCompnayInfo.tenantEmail }}
									</span>
								</div>
							</el-form-item>

						</el-col>
						<el-col :span="24">
							<el-form-item label="投保方案:" prop="insuranceSchemeId">
								<div  v-if="!applyDialogDisabled">
								<el-select v-model="applyData.insuranceSchemeId" placeholder="请选择"
									style="margin-bottom: 20px;width: 340px;" @change=changeValue>
									<el-option v-for="item in InsuranceSchemeList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							
								<div v-if="applyData.insuranceSchemeId > 0" >
									<span class="is-blod">保费：</span>{{ InsuranceSchemeList_item.price }} 元/人
									<table class="cus-table">
										<tr>
											<th>保障对象</th>
											<th>项目</th>
											<th>保额</th>
										</tr>
										<tr v-for="(detail,index) in InsuranceSchemeList_item.details" :key="index">
											<td>{{ detail.name }}</td>
											<td>{{ detail.item }}</td>
											<td>{{ detail.price }}（万元）</td>
										</tr>
									</table>
								<div v-if="applyData.natureOfBusiness==2">
									<span class="is-blod">可选项：</span>
									<p>
										<span class="text-title"
										@click="openDescript('《可选项介绍》', InsuranceSchemeList_item.optionalRemark)" v-if="InsuranceSchemeList_item.optionalRemark!=null&&InsuranceSchemeList_item.optionalRemark!=''"><i class="el-icon-paperclip"></i>《可选项介绍》</span>
									</p>
									
									<el-checkbox-group v-model="applyData.schemeOptionalList" @change="changescheop">
    									<el-checkbox :label="item.id+''"   v-for="(item,index) in InsuranceSchemeList_item.optional" :key="index">{{item.name+' '+item.price+item.unit}}</el-checkbox>
  									</el-checkbox-group>

								</div>
								<div>
									<p><span class="text-title"
										@click="openDescript('《险种介绍》', InsuranceSchemeList_item.describes)" v-if="InsuranceSchemeList_item.describes!=null&&InsuranceSchemeList_item.describes!=''"><i class="el-icon-paperclip"></i>《险种介绍》</span></p>
										<p><span class="text-title"
										@click="openDescript('《保险责任》', InsuranceSchemeList_item.duty)" v-if="InsuranceSchemeList_item.duty!=null&&InsuranceSchemeList_item.duty!=''"><i class="el-icon-paperclip"></i>《保险责任》</span></p>
									<!-- <div class="html-msg">
									<div class="html-msg-box" v-html="InsuranceSchemeList_item.describes"></div>
									</div> -->
								</div>
								</div>
							</div>
								
								<div v-if="applyDialogDisabled && applyData.insuranceSchemeId > 0">
									{{ insuranceSchemeModel.name }} 
									<div><span class="is-blod">保费：</span>  {{ insuranceSchemeModel.price }} (元/人)</div>
									<table class="cus-table">

										<tr>
											<th>保障对象</th>
											<th>项目</th>
											<th>保额</th>
										</tr>
										<tr v-for="(detail,index) in insuranceSchemeModel.details" :key="index">
											<td>{{ detail.name }}</td>
											<td>{{ detail.item }}</td>
											<td>{{ detail.price }}（万元）</td>
										</tr>
									</table>
									<div v-if="applyData.schemeOptionalList.length>0">
									<span class="is-blod" >可选项：</span>
		
									<el-checkbox-group v-model="applyData.schemeOptionalList">
    									<el-checkbox :label="item.id+''"   v-for="(item,index) in insuranceSchemeModel.optional" :key="index">{{item.name+' '+item.price+item.unit}}</el-checkbox>
  									</el-checkbox-group>
									</div>
									<div>	<p><span class="text-title"
										@click="openDescript('《险种介绍》', InsuranceSchemeList_item.describes)" v-if="InsuranceSchemeList_item.describes!=null&&InsuranceSchemeList_item.describes!=''"><i class="el-icon-paperclip"></i>《险种介绍》</span></p>
										<p><span class="text-title"
										@click="openDescript('《保险责任》', InsuranceSchemeList_item.duty)" v-if="InsuranceSchemeList_item.duty!=null&&InsuranceSchemeList_item.duty!=''"><i class="el-icon-paperclip"></i>《保险责任》</span></p>
									
								</div>
								</div>

							</el-form-item>

						</el-col>
						
					</el-row>
					<el-divider content-position="center">附件</el-divider>
					<el-row>	
						<el-col :span="12">
						<el-form-item label="从业人员信息表:" class="form-label">
							<div style="display: flex;">
								<div style="color: #67c23a;"
									v-if="applyData.personnelTable != '' && applyData.personnelTable != null && applyData.personnelTable != undefined">
									已上传</div>
								<div style="color: #999999;" v-else>未上传</div>
								<span 
									class="color-blue pointer "
									style="margin-left: 1.5rem;"
									@click="downloadFile(applyData.personnelTable, '从业人员信息表')"
									v-if="applyData.personnelTable != '' && applyData.personnelTable != null && applyData.personnelTable != undefined">
									<i class="el-icon-download"></i>下载</span>
							</div>
							<el-upload :action="Url + '/api/File/UploadFormFile'" :headers="importHeaders"
								:data="uploadData" :multiple="false" 
								:on-change="function(file,fileList){onChange(file,fileList,'persTFileList')}"
								:before-remove="persTBeforeRemove" :on-success="persTSuccess"
								:before-upload="persTBeforeUpload" :show-file-list="false"
								:file-list="persTFileList" v-if="!applyDialogDisabled">
								<el-button size="small" type="primary">点击上传</el-button>
								<div class="el-upload__tip" style="display: inline-block;">请上传Excle文件</div>
							</el-upload>
							<div v-if="!applyDialogDisabled" class="color-blue pointer"  style="position: relative;right: 94px;top: -35px;display: inline-block;" @click="downloadTemp(5,'安责险人员清单模板');" >
									<i class="el-icon-download"></i>下载模板
							</div>
						</el-form-item>

					</el-col>
					<el-col :span="12">
						<el-form-item label="企业营业执照副本扫描件:" class="form-label">
							<div style="display: flex;">
								<div style="color: #67c23a;"
									v-if="applyData.businessLicense != '' && applyData.businessLicense != null && applyData.businessLicense != undefined">
									已上传</div>
								<div style="color: #999999;" v-else>未上传</div>
								<span 
									class="color-blue pointer "
									style="margin-left: 1.5rem;"
									@click="downloadFile(applyData.businessLicense, '企业营业执照副本扫描件')"
									v-if="applyData.businessLicense != '' && applyData.businessLicense != null && applyData.businessLicense != undefined">

									<i class="el-icon-download"></i>下载</span>
							</div>
							<el-upload :action="Url + '/api/File/UploadFormFile'" :headers="importHeaders"
								:data="uploadData" :multiple="false"
								:on-change="function(file,fileList){onChange(file,fileList,'tenandFiles')}"
								:before-remove="tenandBeforeRemove" :on-success="tenandSuccess"
								:show-file-list="false" :file-list="tenandFiles" v-if="!applyDialogDisabled">
								<el-button size="small" type="primary">点击上传</el-button>
								<div class="el-upload__tip" style="display: inline-block;">请上传文件</div>
							</el-upload>
							<div v-if="!applyDialogDisabled" class="color-blue pointer"  style="position: relative;right: 94px;top: -35px;display: inline-block;"  >
								
							</div>
						</el-form-item>

					</el-col>
					<el-col :span="12">
						<el-form-item label="道路运输经营许可证扫描件:" class="form-label">
							<div style="display: flex;">
								<div style="color: #67c23a;"
									v-if="applyData.roadTransportPermit != '' && applyData.roadTransportPermit != null && applyData.roadTransportPermit != undefined">
									已上传</div>
								<div style="color: #999999;" v-else>未上传</div>
								<span 
									class="color-blue pointer "
									style="margin-left: 1.5rem;"
									@click="downloadFile(applyData.roadTransportPermit, '道路运输经营许可证扫描件')"
									v-if="applyData.roadTransportPermit != '' && applyData.roadTransportPermit != null && applyData.roadTransportPermit != undefined">
									<i class="el-icon-download"></i>下载</span>

							</div>
							<el-upload :action="Url + '/api/File/UploadFormFile'" :headers="importHeaders"
								:data="uploadData" :multiple="false" 
								:on-change="function(file,fileList){onChange(file,fileList,'dlxkFiles')}"
								:show-file-list="false" :before-remove="dlxkBeforeRemove" :on-success="dlxkSuccess"
								:file-list="dlxkFiles" v-if="!applyDialogDisabled">
								<el-button size="small" type="primary">点击上传</el-button>
								<div class="el-upload__tip" style="display: inline-block;">请上传文件</div>
							</el-upload>

						</el-form-item>

					</el-col>
					<el-col :span="12">
						<el-form-item label="投保告知书（加盖投保人公章）:" class="form-label">
							<div style="display: flex;">
								<div style="color: #67c23a;"
									v-if="applyData.notification != '' && applyData.notification != null && applyData.notification != undefined">
									已上传</div>
								<div style="color: #999999;" v-else>未上传</div>
								<span 
									class="color-blue pointer "
									style="margin-left: 1.5rem;"
									@click="downloadFile(applyData.notification, '投保告知书')"
									v-if="applyData.notification != '' && applyData.notification != null && applyData.notification != undefined">
									<i class="el-icon-download"></i>下载</span>
							</div>
							<el-upload :action="Url + '/api/File/UploadFormFile'" :headers="importHeaders"
								:data="uploadData" :multiple="false" 
								:on-change="function(file,fileList){onChange(file,fileList,'tbgzFiles')}"
								:show-file-list="false" :before-remove="tbgzBeforeRemove" :on-success="tbgzSuccess"
								:file-list="tbgzFiles" v-if="!applyDialogDisabled">
								<el-button size="small" type="primary" >点击上传</el-button>
								<div class="el-upload__tip" style="display: inline-block;">请上传文件</div>
							</el-upload>
							<div  v-if="!applyDialogDisabled" class="color-blue pointer"  style="position: relative;right: 94px;top: -35px;display: inline-block" @click="downloadTemp(4,'投保告知书模板');" >
									<i class="el-icon-download"></i>下载模板
							</div>

						</el-form-item>
					</el-col>
					
					</el-row>
				</el-form>
				<div v-if="applyData.status >2">

				<el-divider content-position="center">保单附件</el-divider>
				<!-- <el-form-item label="审核人:"> 
				{{applyData.auditUserName}} -->
				<!-- 蔡徐坤 2022-07-16 -->
				<!--</el-form-item> -->
					<div style="text-align: center;">
						<el-button size="mini" type="success" icon="el-icon-download"
							style="margin-right: 1rem;" @click="downloadFile(applyData.insuranceBill, '保单')"
							v-if="applyData.insuranceBill != '' && applyData.insuranceBill != null && applyData.insuranceBill != undefined">
							下载保单
						</el-button>
						<el-button size="mini" type="info" icon="el-icon-download" style="margin-right: 1rem;"
							@click="downloadFile(applyData.insuranceInvoice, '发票')"
							v-if="applyData.insuranceInvoice != '' && applyData.insuranceInvoice != null && applyData.insuranceInvoice != undefined">
							下载发票
						</el-button>
						<el-button size="mini" type="warning" icon="el-icon-download"
							style="margin-right: 1rem;" @click="downloadFile(applyData.insuranceFile, '保险资料')"
							v-if="applyData.insuranceFile != '' && applyData.insuranceFile != null && applyData.insuranceFile != undefined">
							保险资料
						</el-button>
					</div>
				</div>

			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="caclelisblity" v-if="!applyDialogDisabled">取 消</el-button>
				<el-button @click="caclelisblity" v-if="applyDialogDisabled">关闭</el-button>
				<el-button type="primary" @click="submitLisblity"
					v-if="(applyData.status == 0 || applyData.status == 1) && !applyDialogDisabled">提 交</el-button>
			</div>
			<el-dialog :title="descriptOption.title" :visible.sync="descriptOption.visible" width="60%" append-to-body>
			<div class="doc-content" style="padding:1rem 4rem;height: 70vh;overflow-y: auto;">
				<el-form>
				<el-form-item>
					<div v-html="descriptOption.content"></div>
				</el-form-item>

				</el-form>
			</div>
		</el-dialog>
		</el-dialog>
		<el-dialog title="修改人员信息列表" :visible.sync="uploadPersonVisible" width="30%">
			<el-form label-width="220px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="从业人员信息表:">
							<div style="display: flex;">
								<div style="color: #67c23a;"
									v-if="applyData.personnelTable != '' && applyData.personnelTable != null && applyData.personnelTable != undefined">
									已上传</div>
								<div style="color: #999999;" v-else>未上传</div>
								<el-button size="mini" type="text" icon="el-icon-download" style="margin-left: 1.5rem;"
									@click="downloadFile(applyData.personnelTable, '从业人员信息表')"
									disabled="false"
									v-if="applyData.personnelTable != '' && applyData.personnelTable != null && applyData.personnelTable != undefined">
									下载</el-button>
							</div>
							<el-upload :action="Url + '/api/File/UploadFormFile'" :headers="importHeaders"
								:data="uploadData" :multiple="false" :limit="1" :before-upload="persTBeforeUpload"
								:before-remove="persTBeforeRemove" :on-success="persTSuccess"
								:file-list="persTFileList">
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>

						</el-form-item>

					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="uploadPersonVisible = false">取 消</el-button>

				<el-button type="primary" @click="submituploadperson">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="安全生产责任险说明" :visible.sync="DescDocVisibel" width="60%">
			<div style="padding:1rem 4rem; 1rem 4rem">
				<div class="doc-content">
					<p>本产品主要针对道路运输企业在经营中发生安全生产责任事故导致的赔偿风险，请仔细了解该产品的具体内容后投保。该产品由五洲（北京）保险经纪有限公司云南分公司设计并提供保险经纪人服务。本产品方案已通过“滇运码”项目经纪人审核，属于保险金融帮扶产品
					</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="DescDocVisibel = false">关 闭</el-button>
			</div>
		</el-dialog>
		<el-dialog title="安全生产责任险说明" :visible.sync="CompnayDescVisibel" width="60%">
			<div class="doc-content" style="padding:1rem 4rem; 1rem 4rem">
				<p>五洲（北京）保险经纪有限公司成立于2003年8月8日成立，注册资本金5,000万人民币，总部位于北京，在全国拥有7家分公司及2家子公司。主营业务包括保险经纪业务、再保险经纪业务、风险咨询业务，其中再保险经手保费及经纪费收入在保险经纪市场上位居前列。
				</p>
				<p>作为五洲（北京）保险经纪有限公司在云南设立的省级分公司，五洲（北京）保险经纪有限公司云南分公司于2007年04月02日经保监局批准设立。充分发挥公司自身优势，努力为云南当地的建设、为各企事业单位及居民提供专业、优质的保险经纪服务。
				</p>
				<p>2021年8月17日，五洲（北京）保险经纪有限公司有幸成为云南省应急管理厅“安全生产责任保险公益保险经纪人服务项目”唯一中标保险经纪人。</p>
				<p>联系方式：电话0871-67271595，邮箱wzbxjjywb448@163.com</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="CompnayDescVisibel = false">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import {
	format
} from "date-fns";
import downloadFiles from"@/utils/downloadFiles";
export default {
	filters: {
		//过滤器 用于格式化时间
		formatDate(val) {
			return format(new Date(val), "yyyy-MM-dd");
		},
		formatDateTime(val) {
			return format(new Date(val), "yyyy-MM-dd HH:mm:ss");
		}
	},
	data() {
		var checkPerson = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('投保人数不能为空！'));
			}
			setTimeout(() => {
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字值'));
				} else {
					if (value < 1) {
						callback(new Error('必须>1'));
					} else {
						callback();
					}
				}
			}, 1000);
		};

		return {
			tenantId: 0,
			//查询条件
			requestData: {
				SituationOfInsurance: "",
				Name: "",
				serialNo: '',
			},
			//投保情况
			SituationOfInsuranceList: [],
			//经营范围
			NatureOfBusinessList: [],
			//保险公司
			InsuranceCompnayList: [],
			InsuranceSchemeList: [],
			tableData: [],
			loading: false,
			currentPage: 1,
			pageSize: 10,
			total: 0,
			skipCount: 0,
			maxResultCount: 10,
			//上传文件
			importHeaders: {
				Authorization: "",
			},
			//人员信息表文件列表
			persTFileList: [],
			//企业营业执照副本扫描件
			tenandFiles: [],
			//道路运输经营许可证扫描件
			dlxkFiles: [],
			//投保告知书
			tbgzFiles: [],
			uploadData: {
				fileCategory: 18,
			},
			//编辑
			applyDialogVisible: false,
			applyDialogTitle: '',
			applyDialogDisabled: false,
			applyData: {},
			applyData_rules: {
				name: [{
					required: true,
					message: '请输入企业名称',
					trigger: 'blur'
				}],
				socialCreditCode: [{
					required: true,
					message: '请输入单位统一社会信用代码',
					trigger: 'blur'
				}],

				contacts: [{
					required: true,
					message: '请输入联系人',
					trigger: 'blur'
				}],
				contactPhone: [{
					required: true,
					message: '请输入联系电话',
					trigger: 'blur'
				}],
				email: [{
					required: true,
					message: '请输入邮箱',
					trigger: 'blur'
				},
				{
					type: 'email',
					message: '请输入正确的邮箱地址',
					trigger: ['blur', 'change']
				}
				],
				adress: [{
					required: true,
					message: '请输入通信地址',
					trigger: 'blur'
				}],
				insuranceSchemeId: [{
					required: true,
					message: '请选择投保方案',
					trigger: 'change'
				}],
				personNum: [{
					validator: checkPerson,
					trigger: 'blur'
				}],
				name_Insured: [{
					required: true,
					message: '请输入企业名称',
					trigger: 'blur'
				}],
				socialCreditCode_Insured: [{
					required: true,
					message: '请输入单位统一社会信用代码',
					trigger: 'blur'
				}],

				contacts_Insured: [{
					required: true,
					message: '请输入联系人',
					trigger: 'blur'
				}],
				contactPhone_Insured: [{
					required: true,
					message: '请输入联系电话',
					trigger: 'blur'
				}],
				email_Insured: [{
					required: true,
					message: '请输入邮箱',
					trigger: 'blur'
				},
				{
					type: 'email',
					message: '请输入正确的邮箱地址',
					trigger: ['blur', 'change']
				}
				],
				adress_Insured: [{
					required: true,
					message: '请输入通信地址',
					trigger: 'blur'
				}]
			},
			uploadPersonVisible: false,
			insuranceSchemeModel: {},
			DescDocVisibel: false,
			CompnayDescVisibel: false,
			insuranceCompnayInfo: {
				name: "",
				organizationCode: "",
				tenancyName: null,
				tenantEmail: "",
				tenantPhone: ""
			},
			//是否显示按钮
			isBtn: true,

			//获取当前选项的投保方案
			InsuranceSchemeList_item: {},
			descriptOption: {
				title: '',
				content: '',
				visible: false
			}

		};
	},
	mounted() {

		this.tenantId = localStorage.getItem("userId");
		//console.log(tenantId);
		this.GetEnumList();
		this.getTenantList();
	},
	created() {
		//获取地址栏，判断是否显示按钮

		var r = window.location.hash;
		if (r.indexOf('financial-insurance_lisblity') > -1) {
			this.isBtn = false;
		}

		// this.getFinancialState();
		var accessToken = localStorage.getItem("accessToken");
		this.importHeaders.Authorization = "Bearer " + accessToken;
		this.getData();
	},
	methods: {
		getData() {
			let queryData = {
				params: {
					skipCount: this.skipCount,
					maxResultCount: this.maxResultCount,
					name: this.requestData.Name,
					situationOfInsurance: this.requestData.SituationOfInsurance,
					serialNo: this.requestData.serialNo
				}
			};
			this.loading = true;
			this.$http
				.get("/api/services/app/LisblityInsurance/GetAll", queryData)
				.then(res => {
					this.loading = false;
					if (res.data.success) {
						let rtnResult = res.data.result;
						this.total = rtnResult.totalCount;
						this.tableData = rtnResult.items;
					}
				})
				.catch(err => {
					this.loading = false;
				});


		},
		handleSizeChange(val) {
			this.maxResultCount = val;
			this.getData();
		},
		handleCurrentChange(val) {
			this.skipCount = (val - 1) * this.maxResultCount;
			this.getData();
		},
		//查询
		search() {
			this.getData();

		},
		//添加
		applyHandler(editData, type) {
			let _this = this;


			if (editData == null) {
				_this.applyData = {
					id: 0,
					isIdentical: true,
					situationOfInsurance: 1,
					name: "",
					socialCreditCode: "",
					contacts: "",
					contactPhone: "",
					email: "",
					adress: "",
					name_Insured: "",
					socialCreditCode_Insured: "",
					contacts_Insured: "",
					contactPhone_Insured: "",
					email_Insured: "",
					adress_Insured: "",
					natureOfBusiness: _this.NatureOfBusinessList[0].value,
					personNum: 0,
					insuranceSchemeId: 0,
					personnelTable: "",
					businessLicense: "",
					businessLicense_Insured: "",
					roadTransportPermit: "",
					roadTransportPermit_Insured: '',
					notification: "",
					notification_Insured: '',
					schemeOptionalList:[],
					insuranceCompnayId: 0,//1479测试，2989
					status: 0,
					tenantId: _this.tenantId
				}
				_this.getTenantInfo();


			} else {

				_this.applyData = JSON.parse(JSON.stringify(editData));


			}
			let compnayInfo=null;
      if( _this.applyData.insuranceCompnayId==0){
        compnayInfo=_this.InsuranceCompnayList[0];
        _this.applyData.insuranceCompnayId= compnayInfo.id;
      }else{
        compnayInfo = _this.InsuranceCompnayList.find((x) => x.id == _this.applyData.insuranceCompnayId);
      }
			
			if (compnayInfo != null) {
				_this.insuranceCompnayInfo.id = compnayInfo.id;
				_this.insuranceCompnayInfo.name = compnayInfo.name;
				_this.insuranceCompnayInfo.organizationCode = compnayInfo.organizationCode;
				_this.insuranceCompnayInfo.tenancyName = compnayInfo.tenancyName;
				_this.insuranceCompnayInfo.tenantEmail = compnayInfo.tenantEmail;
				_this.insuranceCompnayInfo.tenantPhone = compnayInfo.tenantPhone;
			}
			_this.persTFileList = [];
			_this.tenandFiles = [];
			_this.dlxkFiles = [];
			_this.tbgzFiles = [];
			_this.applyData.insuranceScheme = {
				// id: 0,
				// name: '',
				// price: 0,
				// details: []
			};
			switch (type) {
				case "add":
					_this.applyDialogTitle = "申请投保";
					_this.applyDialogDisabled = false;
					_this.applyData.status = 0;
					_this.getInsuranceScheme(_this.applyData.insuranceCompnayId);
					break;
				case "edit":
					_this.applyDialogTitle = "编辑投保信息";
					_this.applyDialogDisabled = false;
					_this.applyData.status = 0;
					_this.getInsuranceScheme(_this.applyData.insuranceCompnayId);
					break;
				case "see":
					_this.applyDialogTitle = "查看详情";
					_this.applyDialogDisabled = true;
					_this.insuranceSchemeModel = {};
					_this.$http.get('/api/services/app/InsuranceScheme/Get?id=' + editData.insuranceSchemeId).then(
						resdata => {

							_this.$nextTick(() => {
								_this.insuranceSchemeModel = resdata.data.result;
								
							});

						});
					break;
			}


			_this.applyDialogVisible = true;
		},
		//修改人员信息表
		uploadPerson(row) {
			//获取从业人员信息表
			let _this = this;
			_this.applyData = JSON.parse(JSON.stringify(row));
			_this.persTFileList = [];
			_this.uploadPersonVisible = true;
		},
		submituploadperson() {
			let _this = this;
			//编辑
			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)"
			});
			_this.$http
				.put("/api/services/app/LisblityInsurance/Update", _this.applyData)
				.then((res) => {
					loading.close();
					if (res.data.success) {
						_this.$message({
							message: "操作成功",
							type: "success",
						});
						_this.uploadPersonVisible = false;
						_this.persTFileList = [];
						_this.getData();

					}
				})
				.catch((err) => {
					loading.close();
				});
		},
		reset() {
			this.requestData = {
				SituationOfInsurance: "",
				Name: ""
			};
			this.skipCount = 0;
			this.maxResultCount = 10;
			this.getData();
		},
		//获取Enum
		GetEnumList() {
			this.SituationOfInsuranceList = [];
			let _this = this;
			this.getEnumDropDownList("InsuranceSituation").then(res => {
				if (res.data.success) {
					let rtnResult = res.data.result;

					_this.SituationOfInsuranceList = rtnResult;
				}
			});
			this.getEnumDropDownList("NatureOfBusiness").then(res => {
				if (res.data.success) {
					let rtnResult = res.data.result;
					_this.NatureOfBusinessList = rtnResult;
				}
			});
		},

		getEnumDropDownList(enumName) {
			return this.$http.get(`/api/Enum/GetDropDownList?EnumName=${enumName}`);
		},

		caclelisblity() {
			this.$refs.ruleForm.resetFields();
			this.applyDialogVisible = false;
		},
		submitLisblity() {
			let _this = this;
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					if (_this.applyData.insuranceSchemeId < 1) {
						_this.$message.warning("请选择投保方案！");
						return;
					}
					if (_this.applyData.notification == '' || _this.applyData.notification == null || _this
						.applyData.notification == undefined) {
						_this.$message.warning("请上传投保告知书");
						return;
					}
					if (_this.applyData.businessLicense == '' || _this.applyData.businessLicense == null ||
						_this.applyData.businessLicense == undefined) {
						_this.$message.warning("请上传投保企业营业执照副本");
						return;
					}

					if (_this.applyData.roadTransportPermit == '' || _this.applyData.roadTransportPermit ==
						null || _this.applyData.roadTransportPermit == undefined) {
						_this.$message.warning("请上传道路运输经营许可证扫描件");
						return;
					}
					if (_this.applyData.isIdentical != true) {
						if (_this.applyData.notification_Insured == '' || _this.applyData
							.notification_Insured == null || _this.applyData.notification_Insured == undefined
						) {
							_this.$message.warning("请上传[被保险人]投保告知书");
							return;
						}
						if (_this.applyData.businessLicense_Insured == '' || _this.applyData
							.businessLicense_Insured == null || _this.applyData.businessLicense_Insured ==
							undefined) {
							_this.$message.warning("请上传[被保险人]投保企业营业执照副本");
							return;
						}

						if (_this.applyData.roadTransportPermit_Insured == '' || _this.applyData
							.roadTransportPermit_Insured == null || _this.applyData
								.roadTransportPermit_Insured == undefined) {
							_this.$message.warning("请上传[被保险人]道路运输经营许可证扫描件");
							return;
						}
					}

					const loading = this.$loading({
						lock: true,
						text: "Loading",
						spinner: "el-icon-loading",
						background: "rgba(0, 0, 0, 0.7)",
					});
					if (_this.applyData.id > 0) {
						//编辑
						_this.$http
							.put("/api/services/app/LisblityInsurance/Update", _this.applyData)
							.then((res) => {
								loading.close();
								if (res.data.success) {
									_this.$message({
										message: "操作成功",
										type: "success",
									});
									_this.caclelisblity();
									_this.getData()
								}
							})
							.catch((err) => {
								loading.close();
							});
					} else {
						//新增
						_this.$http
							.post("/api/services/app/LisblityInsurance/Create", _this.applyData)
							.then((res) => {
								loading.close();
								if (res.data.success) {
									_this.$message({
										message: "操作成功",
										type: "success",
									});
									_this.caclelisblity();
									_this.getData()
								}
							})
							.catch((err) => {
								loading.close();
							});
					}

				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		getTenantInfo() {
			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});
			this.$http
				.post("/api/services/app/Tenant/GetTenantInfo", {
					id: this.tenantId,
				})
				.then((res) => {
					loading.close();
					if (res.data.success) {
						var rtnResult = res.data.result;

						this.applyData.name = rtnResult.name;
						this.applyData.socialCreditCode = rtnResult.organizationCode;
						this.applyData.adress = rtnResult.address;
						this.applyData.contacts = rtnResult.legalPerson;
						this.applyData.contactPhone = rtnResult.contactPhone;
						this.applyData.email = rtnResult.tenantEmail;
					}
				})
				.catch((err) => {
					loading.close();
				});
		},
		//获取保险公司下拉列表
		getTenantList() {
			let _this = this;
			this.$http
				.get("/api/services/app/Tenant/GetExpDropDownList?tenantStyle=9")
				.then((res) => {

					if (res.data.success) {

						_this.InsuranceCompnayList = res.data.result;
					}
				})
				.catch((err) => {

				});
		},
		//获取投保方案
		getInsuranceScheme(TenantID) {
			let _this = this;
			this.$http
				.get("/api/services/app/InsuranceScheme/GetAll?tenantId=" + TenantID + "&type=0")
				.then((res) => {
					if (res.data.success) {

						_this.InsuranceSchemeList = res.data.result.items;
						// console.log(res.data.result.items[0]);
						// console.log(_this.value);
						if (_this.applyData.insuranceSchemeId == 0) {
							_this.applyData.insuranceSchemeId = _this.InsuranceSchemeList[0].id;
							
						}
						_this.changeValue(_this.applyData.insuranceSchemeId);

					}
				})
				.catch((err) => {
				});
		},

		//获取value值
		changeValue(index) {

			this.InsuranceSchemeList_item = this.InsuranceSchemeList.find(x => x.id == index)

		},
		//查看文字描述内容
		openDescript(title, content) {
			this.descriptOption.title = title;
			this.descriptOption.content = content;
			this.descriptOption.visible = true;
		},

		//上传文件
		persTSuccess(file) {
			var that = this;
			that.applyData.personnelTable = file.result.data.fileId;
			this.$message.success("上传成功!");
		},
		persTBeforeUpload(file) {
			const isXlS =
				file.type ===
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
				file.type === "application/vnd.ms-excel";
			//   const isLt2M = file.size / 1024 / 1024 < 2;
			if (!isXlS) {
				this.$message.error("仅支持xls、xlsx格式的文件!");
			}
			return isXlS;

		},
		persTBeforeRemove(file) {
			if (file && file.status === "success") {
				return this.$confirm(`确定移除 ${file.name}？`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$message({
						type: "success",
						message: "已删除",
					});
					this.persTFileList = [];
					this.applyData.personnelTable = "";
				});
			}

		},

		//上传文件
		tenandSuccess(file) {
			var that = this;
			that.applyData.businessLicense = file.result.data.fileId;
			this.$message.success("上传成功!");
		},
		tenandBeforeRemove(file) {
			if (file && file.status === "success") {
				return this.$confirm(`确定移除 ${file.name}？`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$message({
						type: "success",
						message: "已删除",
					});
					this.tenandFiles = [];
					this.applyData.businessLicense = "";
				});
			}
		},

		//上传文件
		dlxkSuccess(file) {
			var that = this;
			that.applyData.roadTransportPermit = file.result.data.fileId;
			this.$message.success("上传成功!");
		},
		dlxkBeforeRemove(file) {
			if (file && file.status === "success") {
				return this.$confirm(`确定移除 ${file.name}？`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$message({
						type: "success",
						message: "已删除",
					});
					this.dlxkFiles = [];
					this.applyData.roadTransportPermit = "";
				});
			}
		},
		//上传文件
		tbgzSuccess(file) {
			var that = this;
			that.applyData.notification = file.result.data.fileId;
			this.$message.success("上传成功!");
		},
		tbgzBeforeRemove(file) {
			if (file && file.status === "success") {
				return this.$confirm(`确定移除 ${file.name}？`, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$message({
						type: "success",
						message: "已删除",
					});
					this.tbgzFiles = [];
					this.applyData.notification = "";
				});
			}
		},
		//上传文件
		uploadSuccess(res, file, fileList, type) {
			var that = this;
			switch (type) {
				case 'notification_Insured':
					that.applyData.notification_Insured = res.result.data.fileId;

					break;
				case 'roadTransportPermit_Insured':
					that.applyData.roadTransportPermit_Insured = res.result.data.fileId;
					break;
				case 'businessLicense_Insured':
					that.applyData.businessLicense_Insured = res.result.data.fileId;
					break;
			}
			this.$message.success("上传成功!");
		},
		// 上传文件失败
		handleExceed() {
			this.$message.warning("请先删除，再上传");
		},
		onChange(file,fileList,type){
			let _this=this;
			// console.log(file)
			if (fileList.length > 0) {
				switch(type){
					case 'tbgzFiles':
					_this.tbgzFiles=[fileList[fileList.length - 1]]
						break;
					case 'dlxkFiles':
					_this.dlxkFiles= [fileList[fileList.length - 1]]
						break;
					case 'tenandFiles':
					_this.tenandFiles= [fileList[fileList.length - 1]]
						break;
					case 'persTFileList':
					_this.persTFileList= [fileList[fileList.length - 1]]
						break;
				}
				
			}
		},
		downloadFile(fileId, fileName) {

			let loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});
			this.$http.get(`/api/File/DownFile/${fileId}`, {
				responseType: "blob",
			})
				.then((res) => {
					if (res.status === 200 && res.data) {
						let rtnResult = res.data;
						// console.log(rtnResult);
						let fileUrl = window.URL.createObjectURL(rtnResult);
						let fileLink = document.createElement("a");
						fileLink.href = fileUrl;
						fileLink.setAttribute(
							"download",
							`${fileName + "-" + format(new Date(), "yyyyMMddHHmmss")}`
						);

						document.body.appendChild(fileLink);
						fileLink.click();
						loading.close();
					}
				})
				.catch((err) => {
					console.log(err);
					loading.close();
				});
		},
		changeCompnay(e) {
			this.insuranceCompnayInfo.name = e.name;
			this.insuranceCompnayInfo.organizationCode = e.organizationCode;
			this.insuranceCompnayInfo.tenancyName = e.tenancyName;
			this.insuranceCompnayInfo.tenantEmail = e.tenantEmail;
			this.insuranceCompnayInfo.tenantPhone = e.tenantPhone;
		},
		changescheop(e){
			console.log(e)
		},
		downloadTemp(type,name) {
		downloadFiles.downloadTemp(type,name);
      
    },
	}
};
</script>

<style lang="scss" scoped>
/*险种介绍*/
.text-title {
	color: #409EFF;
	cursor: pointer;
}

.html-msg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, .5);
	z-index: 9;
}

.inner-block {
	display: inline-block;
}

.line-height-40 {
	line-height: 40px;
}

.is-pad-0-20 {
	padding: 0 20px;
}

.fang-radio {

	margin-bottom: 30px;
}

.fang-radio ::v-deep .el-radio__inner {

	border-radius: 0px !important;

}

//修改radio为方框
.fang-radio ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
	content: '';
	width: 8px;
	height: 3px;
	border: 2px solid white;
	border-top: transparent;
	border-right: transparent;
	text-align: center;
	display: block;
	position: absolute;
	top: 2px;
	left: 1px;
	vertical-align: middle;
	transform: rotate(-45deg);
	border-radius: 0px;
	background: none;
}

.cus-table {
	width: 80%;

	td {
		padding: 5px 8px;
		border: 1px solid #f1f4f6;
		vertical-align: middle;
		text-align: center;
	}

	th {
		padding: 5px 8px;
		border: 1px solid #f1f4f6;
		vertical-align: middle;
		font-weight: bold;
		// color: #000000;
	}
}

.form-disable-none {
	::v-deep.el-input__inner {
		color: #606266 !important;
		background-color: #ffffff;

		border: 0;


	}

	::v-deep .is-disabled .is-checked>.el-radio__inner {
		color: #606266 !important;
		border-color: #409EFF !important;
		background-color: #409EFF !important;
	}

	::v-deep.el-radio__label {
		color: #606266 !important;
	}
	::v-deep.el-checkbox__inner{
		color: #606266 !important;
		border-color: #409EFF !important;
		background-color: #409EFF !important;
		
	}
	::v-deep.el-checkbox__label {
		color: #606266 !important;
	}
}

.is-grid {
	display: grid !important;
}



.doc-content {
	p {
		text-indent: 2em;
		line-height: 30px;
		letter-spacing: 1.8px;
	}
}

.form-label {
	::v-deep .el-form-item__label {
		width: 220px !important;
	}

	::v-deep .el-form-item__content {
		margin-left: 220px !important;
	}
}

::v-deep.el-textarea {
	width: 85%;
}
</style>
